import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo-csvbv.png";

export const Footer: React.FC = () => {
  const [logoOk, setLogoOk] = React.useState(true);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              {logoOk ? (
                <img
                  src={logo}
                  alt="CSVBV"
                  className="h-10 w-10 rounded-full bg-white object-contain p-1"
                  loading="lazy"
                  onError={() => setLogoOk(false)}
                />
              ) : (
                <div className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center">
                  <i className="ri-volleyball-line text-white text-xl" />
                </div>
              )}
              <span className="text-xl font-bold">CSVBV</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Le Club Sportif Volley-Ball de Viarmes vous accueille dans une ambiance conviviale
              pour pratiquer le volley-ball à tous les niveaux.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill text-xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer" aria-label="X">
                <i className="ri-twitter-line text-xl" />
              </a>
            </div>
          </div>

          {/* Navigation rapide */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Navigation</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-orange-400 transition-colors">Accueil</Link></li>
              <li><Link to="/equipes" className="text-gray-300 hover:text-orange-400 transition-colors">Équipes</Link></li>
              <li><Link to="/galerie" className="text-gray-300 hover:text-orange-400 transition-colors">Galerie</Link></li>
              <li><Link to="/bureau" className="text-gray-300 hover:text-orange-400 transition-colors">Bureau</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-orange-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Contact</h3>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-orange-400 mt-0.5" />
                <span className="text-sm">Gymnase Municipal<br />95270 Viarmes</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-orange-400" />
                <a href="tel:+33641754877" className="text-sm hover:text-orange-400 transition-colors">06 41 75 48 77</a>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-orange-400" />
                <a href="mailto:contact@volleyball-viarmes.fr" className="text-sm hover:text-orange-400 transition-colors">
                  contact@volleyball-viarmes.fr
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">© 2025 CSVBV - Club Sportif Volley-Ball de Viarmes. Tous droits réservés.</p>
            <div className="mt-4 md:mt-0">
              <a href="https://volleyball-viarmes.fr" className="text-gray-400 hover:text-orange-400 text-sm transition-colors">
                volleyball-viarmes.fr
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
